<div class="uk-container">
	<div class="ServicesHeading">
		<div class="ServicesHeading_Title">
			<h1>Результаты поиска по запросу «{{ searchPhrase }}»</h1>
		</div>
	</div>
</div>

<div class="uk-container">
	<div class="ContainerSmall">
		<form class="FormSearch uk-margin-xlarge-bottom" action="#" method="post" #searchForm="ngForm" (ngSubmit)="newSearch()">
			<input class="uk-input" type="text" name="search" placeholder="Введите запрос" [(ngModel)]="currentSearchPhrase" required>
			<button class="FormSearch_Btn" type="submit" [disabled]="loadingState || !searchForm.form.valid">
				<span class="IconItem IconItem--search">
					<img src="/assets/img/icon/search.svg" uk-svg>
				</span>
			</button>
		</form>

		<div class="SearchResult" *ngIf="results.length > 0">
			<div class="uk-grid uk-grid-collapse">
				<!-- <div class="SearchResult_LeftCol uk-width-2-5 uk-width-1-4@m">
					<span class="SearchResult_LeftCol_Icon">
						<span class="IconItem uk-text-primary">
							<img src="/assets/img/icon/case.svg" uk-svg="width: 26; height: 26">
						</span>
					</span>
					<span>Магазин</span>
				</div> -->

				<div class="SearchResult_RightCol uk-width-1-1">
					<div class="SearchResult_Item" *ngFor="let item of results">
						<h2 class="SearchResult_Item_Heading">
							<a class="uk-link-reset"
								[routerLink]="item.ITEM_ID.startsWith('S') ? ['/catalog/section/', item.ITEM_ID.substr(1)] : ['/catalog', item.ITEM_ID]"
								[innerHtml]="item.TITLE_FORMATED"
							></a>
						</h2>

						<p class="uk-margin-small-bottom" [innerHtml]="item.BODY_FORMATED"></p>

						<div class="SearchResult_Crumbs">
	                        <ul *ngIf="item.CRUMBS" class="uk-breadcrumb">
	                            <li *ngFor="let crumb of item.CRUMBS">
									<a [class]="crumb.color ? crumb.color + '-bg-a' : ''" [routerLink]="crumb.href">{{crumb.name}}</a>
								</li>
	                        </ul>
	                    </div>
					</div>
				</div>
			</div>
		</div>

		<div *ngIf="results.length === 0">
			<div class="uk-alert-warning" uk-alert>
				<h3>Безрезультатно</h3>
			</div>
		</div>

		<div class="uk-margin-xlarge-top" *ngIf="isPaginationReady">
			<app-pagination
				[loadingState]="loadingState"
				[countPages]="countPages"
				(pageChange)="changePage($event)"
			></app-pagination>
		</div>
	</div>
</div>
